const env = process.env.REACT_APP_ENV;

export const API_ENDPOINT = {
    test: 'https://doappstest.dteenergy.com/tea/MobileTimeEntryAppService',
    prod: 'https://doapps.dteenergy.com/tea/MobileTimeEntryAppService'
}[env];
